import React from 'react';
import HumanFigure from './HumanFigure';
import './humanGrid.css';

const HumanGrid = ({ riskPercentage }) => {
    const totalFigures = 100;
    const filledFigures = Math.round(totalFigures * (riskPercentage / 100));
    const unfilledFigures = totalFigures - filledFigures;

    const figures = [];
    for (let i = 0; i < filledFigures; i++) {
        figures.push(<HumanFigure key={i} filled />);
    }
    for (let i = 0; i < unfilledFigures; i++) {
        figures.push(<HumanFigure key={i + filledFigures} />);
    }

    return (
        <div className="grid-container">
            <div className="legend-and-grid">
                <div className="legend">
                    {[100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0].map((num, index) => (
                        <div key={index} className="legend-item">{num} --</div>
                    ))}
                </div>
                <div className="grid" data-testid="human-figure-grid">
                    {figures.reverse()} {/* Reverse the figures to fill from bottom left */}
                </div>
            </div>
            <div className="explanation">
                <div className="figure-text">
                    <HumanFigure filled={false} />
                    <p>
                        <strong>{unfilledFigures} out of 100 people</strong> with similar PGC results are <strong>NOT</strong> expected to die of prostate cancer if undergoing active surveillance
                    </p>
                </div>
                <div className="figure-text">
                    <HumanFigure filled={true} />
                    <p>
                        <strong>{filledFigures} out of 100 people</strong> with similar PGC results are expected to die of prostate cancer if undergoing active surveillance
                    </p>
                </div>
            </div>
        </div>
    );
};

export default HumanGrid;
